import * as React from 'react';
import styled from 'styled-components';

import leafImageRight from '../images/home/leafRight.png';

const Section = styled.section`
	align-items: center;
	background-color: #232338;
	color: white;
	margin-top: 8em;
	margin-bottom: 4em;
	padding-bottom: 0;

	@media (${(props) => props.theme.mediumUp}) {
		margin-top: 3em;
		margin-bottom: 6em;
	}

	& .centeredWrapper {
		padding: 0;
	}

	& article {
		padding: 0 ${(props) => props.theme.paddingMediumUp};
		display: flex;
		width: 100%;
		align-items: center;
		flex-direction: column;
		padding: 2em ${(props) => props.theme.paddingMobile};

		@media (${(props) => props.theme.mediumUp}) {
			padding: 2em ${(props) => props.theme.paddingMediumUp};
			padding-top: 0;
			padding-bottom: 0;
			flex-direction: row;
			justify-content: space-between;

			& q {
				margin-top: 1em;
				margin-left: 1em;
			}
		}

		& figure {
			min-width: 150px;
			margin-top: 1em;
			margin-bottom: 1em;

			@media (${(props) => props.theme.mediumUp}) {
				margin-top: 0;
				margin-bottom: 0;
			}

			@media (${(props) => props.theme.largeUp}) {
				min-width: 163px;
			}

			& img {
				width: 150px;
				max-width: 150px;
				margin-bottom: 1em;

				@media (${(props) => props.theme.largeUp}) {
					width: 163px;
					max-width: 163px;
					margin-bottom: 0;
				}
			}
		}

		& .leaf {
			background-image: ${(props) => `url('${leafImageRight}')`};
			background-repeat: no-repeat;
			background-position: right center;
			padding-right: 45px;
			padding-left: 45px;
			background-size: 66px 132px;

			@media (${(props) => props.theme.mediumUp}) {
				padding-right: 65px;
				padding-left: 0;
				background-size: 100px 200px;
				background-position: right bottom;
			}
		}

		& .quoteAndLogo {
			display: flex;
			flex-direction: column;
			align-items: center;

			@media (${(props) => props.theme.largeUp}) {
				flex-direction: row;
			}

			& .personAndLogo {
				display: flex;
				justify-content: space-between;
				width: 100%;
				@media (${(props) => props.theme.mediumUp}) {
					margin-bottom: 1em;
				}

				& .person {
					margin-bottom: 0;
					font-size: 18px;
					min-width: 120px;
				}
			}
		}

		& header {
			margin-top: -8em;
			text-align: center;
			font-family: ${(props) => props.theme.headingFont};
			background-color: white;
			color: black;
			border-radius: 10px;
			box-shadow: ${(props) => props.theme.roundedBoxShadowHeavy};
			padding: 2em 1em 1.5em;
			margin-bottom: 2em;
			min-width: 250px;

			@media (${(props) => props.theme.mediumUp}) {
				margin-top: -2em;
				margin-bottom: -2em;
			}

			& img {
				border-radius: 50%;
				margin-bottom: 1em;
				min-width: 163px;
				flex-shrink: 1;
			}

			& h3 {
				font-size: 18px;
				margin-bottom: 0;
			}
		}

		&.noPortrait {
			& q {
				font-size: 20px;
				font-weight: 400;
				margin-left: 0;
				margin-right: 1em;
				padding-top: 0;
				position: relative;
				font-family: ${(props) => props.theme.headingFont};

				@media (${(props) => props.theme.largeUp}) {
					font-size: 26px;
				}
			}
		}

		&.yesPortrait {
			& q {
				font-size: 20px;
				font-weight: 400;
				padding-top: 0;
				padding-left: 60px;
				position: relative;
				font-family: ${(props) => props.theme.headingFont};
				max-width: 482px;

				@media (${(props) => props.theme.largeUp}) {
					max-width: 775px;
					font-size: 26px;
					padding-right: 1em;
				}

				&:before {
					content: '“';
					font-size: 110px;
					font-weight: 600;
					line-height: 26px;
					left: 0;
					top: 30px;
					position: absolute;
				}
			}
		}

	}
`;

const Testimonial = (props: any) => (
	<Section className='testimonial full-width'>
		<div className='centeredWrapper'>
				{props.portrait ? (
					<article className='yesPortrait'>
						<div className='leaf'>
							<header>
								<img
									src={props.portrait}
									alt={props.portraitAlt}
									title={props.portraitAlt}
								/>
								<h3>{props.name}<br /><br />{props.title}<br />{props.company}</h3>
							</header>
						</div>
						<div className='quoteAndLogo'>
							<q>{props.quote}</q>
							<figure>
								<img src={props.logo} alt={props.logoAlt} />
							</figure>
						</div>
					</article>
				) : (
					<article className='noPortrait'>
						<div className='quoteAndLogo'>
							<q>{props.quote}</q>
							<div className='personAndLogo'>
								<p className='person'>{props.name}<br />{props.title}<br />{props.company}</p>
								<figure>
									<img src={props.logo} alt={props.logoAlt} />
								</figure>
							</div>
						</div>
					</article>
				)}
		</div>
	</Section>
);

export default Testimonial;
